import React from 'react';
import Error from './Error';

export function UnhandledException({ title = "Error", message = "An unexpected error occured processing your request, please try again." }) {
    return (<Error title={title} message={message} />);
}